import React, { useEffect, useState } from "react"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { getFieldError, spacedNum } from "../../CommonHelper"

export const CommonInput: React.FC<{
  typeName: string
  label?: string
  placeholder: string
  name: string
  value: string | undefined
  errorModel?: IErrorModel
  _callback: (value: string | undefined) => void
  disabled?: boolean
  readonly?: boolean
  customError?: string
  maxLength?: number
}> = ({
  typeName,
  label,
  placeholder,
  name,
  value,
  errorModel,
  _callback,
  disabled,
  readonly,
  customError,
  maxLength
}) => {
  const [localValue, setLocalValue] = useState<string | undefined>(value)
  const MAX_DATE = new Date()

  useEffect(() => {
    setLocalValue(typeName === "number" ? (value ? spacedNum(value) : undefined) : value)
  }, [value])

  useEffect(() => {
    _callback(localValue)
  }, [localValue])

  const changeValue = (val: string | undefined) => {
    if (typeName === "number") {
      if (!val || val.length === 0) {
        setLocalValue("")
        return
      }
      val = val.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1")
      setLocalValue(spacedNum(val))
    } else {
      setLocalValue(val)
    }
  }

  // const checkDateString = (val: string | undefined) => {
  //   if (val && new Date(val) > MAX_DATE && val.length >= 10) {
  //     setLocalValue(dateToInputString(MAX_DATE))
  //   } else if (val && new Date(val) < MIN_DATE && val.length >= 10) {
  //     setLocalValue(dateToInputString(MIN_DATE))
  //   } else {
  //     setLocalValue(val)
  //   }
  // }

  return (
    <fieldset
      style={{
        ...(disabled ? { pointerEvents: "none", opacity: 0.7 } : {}),
        ...(readonly ? { pointerEvents: "none" } : {})
      }}
    >
      {label && <legend>{label}</legend>}
      <input
        type={typeName === "number" ? "text" : typeName}
        className={`input-form${typeName === "date" ? "-date" : ""}`}
        placeholder={placeholder}
        onChange={e => changeValue(e.target.value)}
        max={typeName === "date" ? `${MAX_DATE.toISOString().split("T")[0]}` : ""}
        min={typeName === "date" ? "2023-12-31" : ""}
        value={localValue}
        maxLength={maxLength}
      />
      {getFieldError(errorModel, name) ? <p className="error-form">{getFieldError(errorModel, name)}</p> : <></>}
      {customError ? <p className="error-form">{customError}</p> : <></>}
    </fieldset>
  )
}
